import type { EnvMode } from '../../../vite.config'

export const currentEnvMode = import.meta.env.MODE as EnvMode

export const isTestMode = currentEnvMode === 'test'
export const isDevMode = currentEnvMode === 'development'
export const isIntegrationMode = currentEnvMode === 'integration'
export const isProdMode = currentEnvMode === 'production'

export type { EnvMode }